module.exports = __webpack_public_path__ + "img/vol02_cup01_cover04.d2f3016b.jpg";